import Ajax from '../../../../common/js/Ajax.js';
import ButtonUtils from '../../../../common/js/ButtonUtils.js';
import Dialog from '../../../../common/js/dialog/Dialog.js';
import Form from '../../../../common/js/form/Form.js';
import LangUtils from '../../../../common/js/LangUtils.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import UrlParser from '../../../../common/js/UrlParser.js';
import Widget from '../../../../common/js/Widget.js';

import DE_TEMPLATE from './IssueWidget-de.hbs';
import DE_DELETE_FAILED_TEMPLATE from './IssueWidget-delete-failed-de.hbs';
import DE_HEADLINE_TEMPLATE from './IssueWidget-headline-de.hbs';
import DE_LOAD_FAILED_TEMPLATE from './IssueWidget-load-failed-de.hbs';
import DE_SAVE_FAILED_TEMPLATE from './IssueWidget-save-failed-de.hbs';
import DE_CREATED_TEMPLATE from './IssueWidget-created-de.hbs';
import DE_COMMENTED_TEMPLATE from './IssueWidget-commented-de.hbs';

import EN_TEMPLATE from './IssueWidget-en.hbs';
import EN_DELETE_FAILED_TEMPLATE from './IssueWidget-delete-failed-en.hbs';
import EN_HEADLINE_TEMPLATE from './IssueWidget-headline-en.hbs';
import EN_LOAD_FAILED_TEMPLATE from './IssueWidget-load-failed-en.hbs';
import EN_SAVE_FAILED_TEMPLATE from './IssueWidget-save-failed-en.hbs';
import EN_CREATED_TEMPLATE from './IssueWidget-created-en.hbs';
import EN_COMMENTED_TEMPLATE from './IssueWidget-commented-en.hbs';


export default class IssueWidget extends Widget {

	constructor($widget) {
		super($widget);

		this.issueId = parseInt(UrlParser.getParams()['id']) || null;		
		var $languageLink = $('.js_language-link');
		$languageLink.attr('href', $languageLink.attr('href') + '?id=' + this.issueId);

		this.spinner();
		Ajax.rpc('/issue', {
			id: this.issueId
		}, result => {
			this.admin = result.admin;
			this.render(result);
		}, error => {
			this.show();
			MessageUtils.error($widget, LangUtils.isGerman()
				? DE_LOAD_FAILED_TEMPLATE() : EN_LOAD_FAILED_TEMPLATE(), error);
		});
	}

	createIssueUrl(issueId) {
		return window.location.href.replace(/\?.*$/, '') + '?id=' + issueId;
	}

	deleteIssue($pressedButton) {
		var $buttons = this.$widget.find('.js_delete-issue, .js_save-issue');
		ButtonUtils.setState($buttons, 'disabled');
		ButtonUtils.setState($pressedButton, 'active');

		Ajax.rpc('/deleteIssue', {id: this.issueId}, () => {
			window.location.href = LangUtils.isGerman() ? '/de/suche' : '/en/search';
		}, error => {
			ButtonUtils.setState($buttons, 'none');
			MessageUtils.error($('.js_messages'), LangUtils.isGerman()
				? DE_DELETE_FAILED_TEMPLATE(this.issueId)
				: EN_DELETE_FAILED_TEMPLATE(this.issueId),
				error);
		});
	}

	getIssueIds() {
		var ids;
		try {
			ids = JSON.parse(sessionStorage['lastSearch']).ids;
		} catch (error) {
			// Ignored
		}

		return ids || [];
	}

	render(result) {
		var issueIds = this.getIssueIds();
		var issueNo = issueIds.indexOf(this.issueId);
		if (issueNo > 0) {
			result.prevIssueUrl = this.createIssueUrl(issueIds[issueNo - 1]);
		}
		if (issueNo >= 0 && issueNo < issueIds.length - 1) {
			result.nextIssueUrl = this.createIssueUrl(issueIds[issueNo + 1]);
		}
		result.issueNo = issueNo + 1;
		result.issueCount = issueIds.length;

		this.$widget.html(LangUtils.isGerman() ? DE_TEMPLATE(result) : EN_TEMPLATE(result));
		this.setPageHeadline(LangUtils.isGerman() ? DE_HEADLINE_TEMPLATE(result) : EN_HEADLINE_TEMPLATE(result));

		this.$widget.find('.js_save-issue').click(event => {
			this.saveIssue($(event.currentTarget));
		})

		this.$widget.find('.js_delete-issue').click(event => {
			var $button = $(event.currentTarget);
			var headline = LangUtils.isGerman() ? 'Thema löschen' : 'Delete issue';
			var message = LangUtils.isGerman()
				? 'Bist du sicher, dass du das Thema und seine gesamte Historie löschen möchtest?'
				: 'Are you sure you want to delete the issue and its entire history?';
			Dialog.question(headline, message, true, headline, () => {
				this.deleteIssue($button);
			});
		})
	}

	saveIssue($pressedButton) {
		var $buttons = this.$widget.find('.js_delete-issue, .js_save-issue');
		ButtonUtils.setState($buttons, 'none');

		if (Form.validate(this.$widget.find('.js_issue-form')).length) {
			return;
		}

		var data = {
			id: this.issueId,
			priority: this.$widget.find('[name="priority"]').val(),
			status: $pressedButton.attr('data-status'),
			project: this.$widget.find('[name="project"]').val(),
			type: this.$widget.find('[name="type"]').val(),
			name: this.$widget.find('[name="name"]').val(),
			description: this.$widget.find('[name="description"]').val(),
			reporter: this.$widget.find('[name="reporter"]').val(),
			notifyReporter: this.$widget.find('[name="notifyReporter"]').is(':checked') ? true : false,
			comment: this.$widget.find('[name="comment"]').val(),
			lang: LangUtils.getLang()
		}

		ButtonUtils.setState($buttons, 'disabled');
		ButtonUtils.setState($pressedButton, 'active');
		Ajax.rpc('/saveIssue', data, issueId => {
			if (!this.issueId) {
				delete sessionStorage['lastSearch'];
			}

			if (this.admin) {
				ButtonUtils.setState($buttons, 'none');
				if (this.issueId) {
					window.location.reload();
				} else {
					window.location.href = this.createIssueUrl(issueId);
				}
			} else {
				$buttons.hide();
				var url = this.createIssueUrl(issueId);
				if (this.issueId) {
					MessageUtils.ok($('.js_messages'), LangUtils.isGerman()
						? DE_COMMENTED_TEMPLATE(url) : EN_COMMENTED_TEMPLATE(url));
				} else {
					MessageUtils.ok($('.js_messages'), LangUtils.isGerman()
						? DE_CREATED_TEMPLATE(url) : EN_CREATED_TEMPLATE(url));
				}
			}
		}, error => {
			ButtonUtils.setState($buttons, 'none');
			MessageUtils.error($('.js_messages'), LangUtils.isGerman()
				? DE_SAVE_FAILED_TEMPLATE(this.issueId)
				: EN_SAVE_FAILED_TEMPLATE(this.issueId),
				error);
		});
	}

}
